import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import LmsCourseResolverErrorList from "./LmsCourseResolverErrorList";
import SEO from "../../../UI/SEO/SEO";
export const getLmsCourseResolverErrorBasePath = () => getAdminBasePath() + "/lmsCourseResolverError";
export const getLmsCourseResolverErrorBaseRoute = () => getAdminBaseRoute() + "/lmsCourseResolverError";
export const getLmsCourseResolverErrorIndexRoute = () => getLmsCourseResolverErrorBaseRoute();
export const getLmsCourseResolverErrorIndexPath = () => getLmsCourseResolverErrorBasePath();
const LmsCourseResolverErrorRoutes = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Course Resolver Errors" }), _jsx(Switch, { children: _jsx(Route, { component: LmsCourseResolverErrorList, path: getLmsCourseResolverErrorIndexRoute() }) })] }));
};
export default LmsCourseResolverErrorRoutes;
